import { MarketLayoutNode } from '@flipster/apis/v2/market/types';
import { flattenMarketLayout } from '@flipster/features/src/shared/market-layout';
import { getQuoteCurrencyDataRef } from '@flipster/features/src/shared/quote-currency';
import { QuoteCurrencyListExceptUsdt } from '@flipster/utils/constants/currency';

import { MarketCarouselType } from './constants';

const carouselIdByDataRef: Partial<Record<string, MarketCarouselType>> = {
  newListings: 'newListings',
  hotTradings: 'hotTradings',
  absFundingRates: 'absFundingRates',
  // USDT 외 quote currency 캐러셀: dataRef(소문자 통화 코드) → 카드 id(통화 코드)
  ...Object.fromEntries(
    QuoteCurrencyListExceptUsdt.map((currency) => [getQuoteCurrencyDataRef(currency), currency] as const),
  ),
};

export const getAllPerpCarouselOrder = (nodes: MarketLayoutNode[] | undefined): MarketCarouselType[] => {
  const order: MarketCarouselType[] = [];
  const seen = new Set<MarketCarouselType>();
  for (const { dataRef } of flattenMarketLayout(nodes)) {
    const id = dataRef ? carouselIdByDataRef[dataRef] : undefined;
    if (id && !seen.has(id)) {
      seen.add(id);
      order.push(id);
    }
  }
  return order;
};
